import Vue from 'vue'
import App from './App.vue'
import router from './router'
import quizDataJSON from '@/assets/data/data.json'
import prizesDataJSON from '@/assets/data/prizes.json'


Vue.config.productionTip = false
Vue.quizData = quizDataJSON;
Vue.prizesData = prizesDataJSON;
Vue.questionMaxCount = 3;
Vue.localStorageName = "shuffledQuestions";

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
